function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

function SvgIconSurveys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "78px",
    height: "68px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.667,213.333c-35.292,0-64,28.708-64,64c0,35.292,28.708,64,64,64c35.292,0,64-28.708,64-64     C298.667,242.042,269.958,213.333,234.667,213.333z M274.208,263.542l-42.667,42.667c-2.083,2.083-4.813,3.125-7.542,3.125     s-5.458-1.042-7.542-3.125l-21.333-21.333c-4.167-4.167-4.167-10.917,0-15.083c4.167-4.167,10.917-4.167,15.083,0L224,283.583     l35.125-35.125c4.167-4.167,10.917-4.167,15.083,0C278.375,252.625,278.375,259.375,274.208,263.542z",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.333,42.667h-42.667c-0.656,0-1.225,0.259-1.849,0.372c-4.313-12.579-16.126-21.706-30.151-21.706h-32.219     C288.427,8.042,272.677,0,256,0s-32.427,8.042-42.448,21.333h-32.219c-14.025,0-25.839,9.126-30.151,21.706     c-0.624-0.113-1.193-0.372-1.849-0.372h-42.667C83.135,42.667,64,61.802,64,85.333v384C64,492.865,83.135,512,106.667,512     h298.667C428.865,512,448,492.865,448,469.333v-384C448,61.802,428.865,42.667,405.333,42.667z M170.667,53.333     c0-5.885,4.781-10.667,10.667-10.667h37.917c3.792,0,7.302-2.021,9.219-5.302c5.844-10.042,16.135-16.031,27.531-16.031     s21.688,5.99,27.531,16.031c1.917,3.281,5.427,5.302,9.219,5.302h37.917c5.885,0,10.667,4.781,10.667,10.667V64     c0,11.76-9.573,21.333-21.333,21.333H192c-11.76,0-21.333-9.573-21.333-21.333V53.333z M359.542,402.208     c-2.083,2.083-4.813,3.125-7.542,3.125c-2.729,0-5.458-1.042-7.542-3.125l-57.744-57.744     c-14.452,11.234-32.368,18.202-52.048,18.202c-47.052,0-85.333-38.281-85.333-85.333c0-47.052,38.281-85.333,85.333-85.333     C281.719,192,320,230.281,320,277.333c0,19.68-6.967,37.596-18.202,52.048l57.744,57.743     C363.708,391.292,363.708,398.042,359.542,402.208z",
    "data-original": "#000000",
    style: {},
    className: ""
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurveys);
export default __webpack_public_path__ + "static/media/icon-surveys.f5673670.svg";
export { ForwardRef as ReactComponent };